// Требования к паролю. Те же правила проверяются на сервере (Judo.Infrastructure.PasswordPolicy),
// здесь они нужны для подсказок и быстрой проверки в формах.

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 128;

export interface PasswordRule {
  id: string;
  label: string;
  test: (password: string) => boolean;
}

export const PASSWORD_RULES: PasswordRule[] = [
  {
    id: 'length',
    label: `Не менее ${PASSWORD_MIN_LENGTH} символов`,
    test: (p) => p.length >= PASSWORD_MIN_LENGTH && p.length <= PASSWORD_MAX_LENGTH,
  },
  {
    id: 'lower',
    label: 'Строчная буква',
    test: (p) => Array.from(p).some((c) => c !== c.toUpperCase()),
  },
  {
    id: 'upper',
    label: 'Заглавная буква',
    test: (p) => Array.from(p).some((c) => c !== c.toLowerCase()),
  },
  {
    id: 'digit',
    label: 'Цифра',
    test: (p) => /\d/.test(p),
  },
];

/** Возвращает текст первой ошибки или null, если пароль подходит. */
export function validatePassword(password: string, email?: string): string | null {
  if (!password) return 'Введите пароль.';

  if (password.length < PASSWORD_MIN_LENGTH) {
    return `Пароль должен содержать не менее ${PASSWORD_MIN_LENGTH} символов.`;
  }
  if (password.length > PASSWORD_MAX_LENGTH) {
    return `Пароль не должен быть длиннее ${PASSWORD_MAX_LENGTH} символов.`;
  }
  if (!PASSWORD_RULES.find((r) => r.id === 'lower')!.test(password)) {
    return 'Пароль должен содержать хотя бы одну строчную букву.';
  }
  if (!PASSWORD_RULES.find((r) => r.id === 'upper')!.test(password)) {
    return 'Пароль должен содержать хотя бы одну заглавную букву.';
  }
  if (!PASSWORD_RULES.find((r) => r.id === 'digit')!.test(password)) {
    return 'Пароль должен содержать хотя бы одну цифру.';
  }
  if (email && password.toLowerCase() === email.trim().toLowerCase()) {
    return 'Пароль не должен совпадать с email.';
  }
  return null;
}
